var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/components/sample-component/sample-component.tsx
import React, { forwardRef } from "react";
import {
  Box,
  HeadingText,
  ParagraphText
} from "@leagueplatform/genesis-core";
var DISPLAY_NAME = "SampleComponent";
var SampleComponent = forwardRef(
  ({ heading, body, css, "data-testid": testId = `GDS-${DISPLAY_NAME}` }, ref) => /* @__PURE__ */ React.createElement(
    Box,
    {
      css,
      className: "GDS-sample-component",
      ref,
      "data-testid": testId
    },
    /* @__PURE__ */ React.createElement(HeadingText, { size: "sm", level: "2" }, heading),
    /* @__PURE__ */ React.createElement(ParagraphText, null, body)
  )
);

// src/components/pagination/pagination.tsx
import * as React4 from "react";
import {
  Box as Box2,
  VisuallyHidden,
  useThemeStrings
} from "@leagueplatform/genesis-core";

// src/components/pagination/components/pagination-link.tsx
import * as React2 from "react";
import {
  TextAction,
  Icon
} from "@leagueplatform/genesis-core";
var PaginationLink = ({
  children,
  isSelected,
  isEllipsis = false,
  isIcon,
  css,
  onClick,
  isDisabled
}) => /* @__PURE__ */ React2.createElement(
  TextAction,
  __spreadValues({
    onClick,
    as: !isEllipsis ? "button" : "span",
    "aria-current": isSelected ? "page" : void 0,
    css: __spreadValues(__spreadValues({
      color: isEllipsis || isDisabled ? "$interactiveIconDisabled" : "inherit",
      minWidth: "$oneAndHalf",
      height: "$oneAndHalf",
      padding: isIcon ? "$none" : "$quarter",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderWidth: "$thin",
      borderStyle: "solid",
      borderColor: "transparent",
      lineHeight: "normal",
      "&:hover": {
        textDecoration: "none"
      },
      "&[disabled]": {
        cursor: "auto"
      }
    }, isEllipsis && { cursor: "default" }), css)
  }, !isEllipsis && { disabled: isDisabled || isSelected }),
  children
);
var PaginationIconLink = (_a) => {
  var _b = _a, {
    children,
    icon
  } = _b, props = __objRest(_b, [
    "children",
    "icon"
  ]);
  return /* @__PURE__ */ React2.createElement(PaginationLink, __spreadProps(__spreadValues({}, props), { isEllipsis: false, isIcon: true }), /* @__PURE__ */ React2.createElement(
    Icon,
    {
      css: {
        width: "calc($oneAndHalf - $borderWidths$thin * 2)",
        height: "calc($oneAndHalf - $borderWidths$thin * 2)",
        borderWidth: "$thin"
      },
      icon,
      "aria-hidden": true
    }
  ), children);
};
var Ellipsis = () => /* @__PURE__ */ React2.createElement(PaginationLink, { isEllipsis: true }, "\u2026");

// src/components/pagination/utils/get-middle-numbers.util.ts
function getMiddlePageNumbersForRange(startPage, endPage) {
  const allPageNumbers = [];
  for (let i = startPage; i <= endPage; i += 1) {
    allPageNumbers.push(i);
  }
  return allPageNumbers;
}
var getMiddleNumbersArray = (currentPage, middleRange, firstPage, lastPage) => {
  if (middleRange % 2 === 0) {
    console.error("MiddleRange must be an odd number");
    return [];
  }
  const totalPages = lastPage - firstPage + 1;
  if (totalPages - 2 <= middleRange) {
    const startPage2 = totalPages > 2 ? firstPage + 1 : firstPage;
    const endPage2 = totalPages > 2 ? lastPage - 1 : lastPage;
    return getMiddlePageNumbersForRange(startPage2, endPage2);
  }
  const middleIndex = Math.floor(middleRange / 2);
  let startPage = currentPage - middleIndex;
  let endPage = currentPage + middleIndex;
  if (startPage <= firstPage) {
    startPage = firstPage + 1;
    endPage = startPage + middleRange - 1;
  } else if (endPage >= lastPage) {
    endPage = lastPage - 1;
    startPage = endPage - middleRange + 1;
  }
  return getMiddlePageNumbersForRange(startPage, endPage);
};

// src/components/pagination/hooks/use-pagination.hook.ts
import * as React3 from "react";
var usePagination = ({
  defaultPage = 1,
  page: pageProp,
  onPageChange
}) => {
  const [currentPage, setCurrentPage] = React3.useState(defaultPage);
  const handlePageChange = React3.useCallback(
    (page) => {
      setCurrentPage(page.pageNumber);
      if (onPageChange) {
        onPageChange(page);
      }
    },
    [onPageChange]
  );
  if (pageProp && onPageChange) {
    return [pageProp, onPageChange];
  }
  return [currentPage, handlePageChange];
};

// src/components/pagination/pagination.tsx
var DISPLAY_NAME2 = "Pagination";
var Pagination = React4.forwardRef(
  ({
    compactMode = false,
    css,
    defaultPage = 1,
    isNextPageActiveOverride,
    isPrevPageActiveOverride,
    label,
    labelNextPage,
    labelPrevPage,
    middleRange = 3,
    onPageChange,
    page: pageProp,
    totalPages,
    "data-testid": testId = `GDS-${DISPLAY_NAME2}`
  }, ref) => {
    const {
      paginationPage,
      paginationLabel,
      paginationLabelFirstPage,
      paginationLabelLastPage,
      paginationLabelNextPage,
      paginationLabelPrevPage
    } = useThemeStrings();
    const [currentPage, onPageClick] = usePagination({
      defaultPage,
      page: pageProp,
      onPageChange
    });
    const [displayedMiddlePages, setDisplayedMiddlePages] = React4.useState([]);
    const isPageNumbersEnabled = compactMode === false && !!totalPages && totalPages > 0;
    const middlePageNumbers = React4.useMemo(() => {
      if (!isPageNumbersEnabled || totalPages <= 2) {
        return [];
      }
      return getMiddleNumbersArray(currentPage, middleRange, 1, totalPages);
    }, [currentPage, middleRange, totalPages, isPageNumbersEnabled]);
    React4.useEffect(() => {
      if (middlePageNumbers) {
        setDisplayedMiddlePages(middlePageNumbers);
      }
    }, [middlePageNumbers, totalPages]);
    const isPreviousEllipsisVisible = displayedMiddlePages[0] - 1 > 1;
    const isNextEllipsisVisible = totalPages && totalPages > displayedMiddlePages[displayedMiddlePages.length - 1] + 1;
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === totalPages;
    const isPrevButtonDisabled = isPrevPageActiveOverride !== void 0 ? !isPrevPageActiveOverride : isFirstPage === true;
    const isNextButtonDisabled = isNextPageActiveOverride !== void 0 ? !isNextPageActiveOverride : isLastPage === true;
    const prevButtonLabel = labelPrevPage != null ? labelPrevPage : paginationLabelPrevPage;
    const nextButtonLabel = labelNextPage != null ? labelNextPage : paginationLabelNextPage;
    if (totalPages === 0) {
      return null;
    }
    return /* @__PURE__ */ React4.createElement(
      Box2,
      {
        as: "nav",
        "aria-label": label != null ? label : paginationLabel,
        css: __spreadValues({
          alignItems: "center",
          display: "flex",
          justifyContent: "flex-start",
          gap: "$one",
          color: "$interactiveActionSubdued",
          '[aria-current="page"]': {
            color: "$interactiveActionPrimary",
            borderColor: "currentColor"
          }
        }, css),
        className: "GDS-pagination",
        "data-testid": testId,
        ref
      },
      /* @__PURE__ */ React4.createElement(
        Box2,
        {
          as: "ul",
          css: {
            alignItems: "center",
            display: "flex",
            gap: "$one",
            listStyleType: "none",
            margin: "$none",
            padding: "$none"
          }
        },
        /* @__PURE__ */ React4.createElement(Box2, { as: "li" }, /* @__PURE__ */ React4.createElement(
          PaginationIconLink,
          {
            isDisabled: isPrevButtonDisabled,
            onClick: () => onPageClick({
              buttonType: "previous",
              pageName: prevButtonLabel,
              pageNumber: currentPage - 1
            }),
            icon: "interfaceChevronBack"
          },
          /* @__PURE__ */ React4.createElement(VisuallyHidden, null, prevButtonLabel)
        )),
        isPageNumbersEnabled && /* @__PURE__ */ React4.createElement(Box2, { as: "li" }, /* @__PURE__ */ React4.createElement(
          PaginationLink,
          {
            onClick: () => onPageClick({
              buttonType: "page",
              pageName: "1",
              pageNumber: 1
            }),
            isSelected: currentPage === 1
          },
          "1 ",
          /* @__PURE__ */ React4.createElement(VisuallyHidden, null, paginationLabelFirstPage)
        )),
        isPreviousEllipsisVisible && /* @__PURE__ */ React4.createElement(Box2, { as: "li" }, /* @__PURE__ */ React4.createElement(Ellipsis, null)),
        isPageNumbersEnabled && displayedMiddlePages.map((page) => /* @__PURE__ */ React4.createElement(Box2, { as: "li", key: `page-${page}` }, /* @__PURE__ */ React4.createElement(
          PaginationLink,
          {
            onClick: () => onPageClick({
              pageNumber: page,
              pageName: `${page}`,
              buttonType: "page"
            }),
            isSelected: page === currentPage
          },
          page !== currentPage && /* @__PURE__ */ React4.createElement(VisuallyHidden, null, paginationPage, " "),
          page
        ))),
        isNextEllipsisVisible && /* @__PURE__ */ React4.createElement(Box2, { as: "li" }, /* @__PURE__ */ React4.createElement(Ellipsis, null)),
        isPageNumbersEnabled && totalPages > 1 && /* @__PURE__ */ React4.createElement(Box2, { as: "li" }, /* @__PURE__ */ React4.createElement(
          PaginationLink,
          {
            onClick: () => onPageClick({
              buttonType: "page",
              pageName: `${totalPages}`,
              pageNumber: totalPages
            }),
            isSelected: currentPage === totalPages
          },
          totalPages,
          " ",
          /* @__PURE__ */ React4.createElement(VisuallyHidden, null, paginationLabelLastPage)
        )),
        /* @__PURE__ */ React4.createElement(Box2, { as: "li" }, /* @__PURE__ */ React4.createElement(
          PaginationIconLink,
          {
            onClick: () => onPageClick({
              buttonType: "next",
              pageName: nextButtonLabel,
              pageNumber: currentPage + 1
            }),
            isDisabled: isNextButtonDisabled,
            icon: "interfaceChevronForward"
          },
          /* @__PURE__ */ React4.createElement(VisuallyHidden, null, nextButtonLabel)
        ))
      )
    );
  }
);
Pagination.displayName = DISPLAY_NAME2;

// src/components/section-header/section-header.component.tsx
import * as React5 from "react";
import {
  HeadingText as HeadingText2,
  ParagraphText as ParagraphText2,
  StackLayout,
  Box as Box3,
  checkIsTextAction
} from "@leagueplatform/genesis-core";
import { uniqueId } from "lodash";
function useTextAction({
  headingId,
  isCtaLabelledByHeading,
  textAction,
  textActionId
}) {
  return React5.useMemo(() => {
    if (!textAction) {
      return null;
    }
    if (checkIsTextAction(textAction) === false) {
      return null;
    }
    return isCtaLabelledByHeading ? React5.cloneElement(textAction, {
      id: textActionId,
      "aria-labelledby": `${textActionId} ${headingId}`
    }) : textAction;
  }, [headingId, isCtaLabelledByHeading, textAction, textActionId]);
}
var SectionHeader = React5.forwardRef(
  ({
    css,
    headingId: id,
    headingLevel = "2",
    isCtaLabelledByHeading,
    subtitle,
    textAction,
    title
  }, ref) => {
    const headingId = React5.useMemo(
      () => id != null ? id : uniqueId("section-heading"),
      [id]
    );
    const textActionId = React5.useMemo(
      () => `${headingId}-text-action`,
      [headingId]
    );
    const TextAction2 = useTextAction({
      headingId,
      isCtaLabelledByHeading,
      textAction,
      textActionId
    });
    return /* @__PURE__ */ React5.createElement(
      StackLayout,
      {
        className: "GDS-section-header",
        css,
        ref,
        spacing: "$half"
      },
      /* @__PURE__ */ React5.createElement(
        StackLayout,
        {
          orientation: "horizontal",
          css: {
            alignItems: "flex-start",
            justifyContent: "space-between",
            width: "100%",
            gap: "$quarter"
          }
        },
        /* @__PURE__ */ React5.createElement(
          HeadingText2,
          {
            size: "lg",
            level: headingLevel,
            css: { flexGrow: 1 },
            id: headingId
          },
          title
        ),
        TextAction2 && /* @__PURE__ */ React5.createElement(Box3, null, TextAction2)
      ),
      subtitle && /* @__PURE__ */ React5.createElement(ParagraphText2, { emphasis: "subtle" }, subtitle)
    );
  }
);

// src/components/sidebar-layout/sidebar-layout.tsx
import React6, { forwardRef as forwardRef4 } from "react";
import {
  Box as Box4,
  queryHelpers
} from "@leagueplatform/genesis-core";
var sidebarWidths = {
  md: "288px",
  lg: "384px"
};
var SidebarLayout = forwardRef4(
  (_a, ref) => {
    var _b = _a, {
      children,
      css,
      mainMinWidth = "50%",
      sidebarSide = "trailing",
      sidebarSize = "md",
      spacing = "$two",
      stretch,
      verticalBreakpoint = "tablet"
    } = _b, props = __objRest(_b, [
      "children",
      "css",
      "mainMinWidth",
      "sidebarSide",
      "sidebarSize",
      "spacing",
      "stretch",
      "verticalBreakpoint"
    ]);
    var _a2;
    const isSidebarTrailing = sidebarSide === "trailing";
    const width = (_a2 = sidebarWidths[sidebarSize]) != null ? _a2 : sidebarSize;
    const breakpoint = React6.useMemo(
      () => queryHelpers.down(verticalBreakpoint),
      [verticalBreakpoint]
    );
    const sidebarStyles = React6.useMemo(
      () => ({
        flexGrow: 1,
        width,
        flexBasis: width,
        [`@media ${breakpoint}`]: {
          width: "auto"
        }
      }),
      [breakpoint, width]
    );
    const mainContentStyles = React6.useMemo(
      () => ({
        flexBasis: 0,
        flexGrow: 999,
        minInlineSize: mainMinWidth
      }),
      [mainMinWidth]
    );
    return /* @__PURE__ */ React6.createElement(
      Box4,
      __spreadValues({
        ref,
        className: "GDS-sidebar-layout",
        css: __spreadValues({
          gap: spacing,
          display: "flex",
          alignItems: stretch ? "stretch" : "flex-start",
          [`@media ${breakpoint}`]: {
            flexDirection: "column",
            alignItems: "initial"
          },
          "& > :first-child": isSidebarTrailing ? mainContentStyles : sidebarStyles,
          "& > :last-child": isSidebarTrailing ? sidebarStyles : mainContentStyles
        }, css)
      }, props),
      children
    );
  }
);
SidebarLayout.displayName = "SidebarLayout";

// src/components/accordion/accordion.tsx
import React7, { forwardRef as forwardRef5 } from "react";
import {
  Box as Box5,
  HeadingText as HeadingText3,
  Icon as Icon2,
  focusOutlineOuter
} from "@leagueplatform/genesis-core";
import { uniqueId as uniqueId2 } from "lodash";
var DISPLAY_NAME3 = "Accordion";
var CSS_CLASS_NAME = "GDS-accordion";
var Accordion = forwardRef5(
  ({
    "data-testid": testId = `GDS-${DISPLAY_NAME3}`,
    children,
    className,
    collapseIcon = "interfaceChevronDown",
    css,
    defaultExpanded = false,
    dividerPosition = "end",
    iconPosition = "end",
    expandIcon = "interfaceChevronUp",
    heading,
    headingLevel = "3",
    headingSize = "lg",
    isExpanded: isExpandedProp,
    onClick: onClickCallback,
    id
  }, ref) => {
    const isControlled = isExpandedProp !== void 0;
    const [isExpanded, setIsExpanded] = React7.useState(defaultExpanded);
    const isExpandedState = React7.useMemo(
      () => isControlled ? isExpandedProp : isExpanded,
      [isControlled, isExpanded, isExpandedProp]
    );
    const composedClassName = React7.useMemo(
      () => [CSS_CLASS_NAME, className].join(" "),
      [className]
    );
    const headingId = React7.useMemo(
      () => id != null ? id : uniqueId2("GDS-accordion-heading-"),
      [id]
    );
    const contentId = React7.useMemo(
      () => uniqueId2("GDS-accordion-content-"),
      []
    );
    if (isControlled && onClickCallback === void 0) {
      console.warn(
        "Accordion is being used in controlled mode without an onClick handler. This will result in a read-only accordion."
      );
    }
    const handleClick = React7.useCallback(() => {
      if (!isControlled) {
        setIsExpanded(!isExpandedState);
      }
      if (onClickCallback) {
        onClickCallback(isExpandedState);
      }
    }, [isControlled, isExpandedState, onClickCallback]);
    const hasDividerStart = dividerPosition === "start" || dividerPosition === "both";
    const hasDividerEnd = dividerPosition === "end" || dividerPosition === "both";
    return /* @__PURE__ */ React7.createElement(
      Box5,
      {
        css: __spreadValues({
          borderBlockColor: "$onSurfaceBorderDefault",
          borderBlockWidth: "$thin",
          borderBlockStartStyle: hasDividerStart ? "solid" : "none",
          borderBlockEndStyle: hasDividerEnd ? "solid" : "none"
        }, css),
        className: composedClassName,
        ref,
        "data-testid": testId
      },
      /* @__PURE__ */ React7.createElement(
        HeadingText3,
        {
          className: `${CSS_CLASS_NAME}-heading`,
          size: headingSize,
          level: headingLevel,
          id: headingId
        },
        /* @__PURE__ */ React7.createElement(
          Box5,
          {
            as: "button",
            className: `${CSS_CLASS_NAME}-button`,
            "aria-expanded": isExpandedState,
            "aria-controls": contentId,
            css: {
              all: "inherit",
              display: "flex",
              gap: "$quarter",
              justifyContent: "space-between",
              alignItems: "flex-start",
              paddingBlock: "$two",
              width: "100%",
              "&:hover": {
                backgroundColor: "$interactiveBackgroundHovered"
              },
              '&[class*="GDS"]:focus': {
                outline: "none"
              },
              '&[class*="GDS"]:focus-visible': __spreadValues({}, focusOutlineOuter)
            },
            onClick: handleClick
          },
          iconPosition === "start" && /* @__PURE__ */ React7.createElement(
            Icon2,
            {
              className: `${CSS_CLASS_NAME}-button-icon`,
              "aria-hidden": true,
              icon: isExpandedState ? collapseIcon : expandIcon
            }
          ),
          /* @__PURE__ */ React7.createElement(
            Box5,
            {
              as: "span",
              css: { flex: 1 },
              className: `${CSS_CLASS_NAME}-button-label`
            },
            heading
          ),
          iconPosition === "end" && /* @__PURE__ */ React7.createElement(
            Icon2,
            {
              className: `${CSS_CLASS_NAME}-button-icon`,
              "aria-hidden": true,
              css: { flexShrink: 0 },
              icon: isExpandedState ? collapseIcon : expandIcon
            }
          )
        )
      ),
      /* @__PURE__ */ React7.createElement(
        Box5,
        __spreadValues({
          id: contentId,
          "aria-labelledby": headingId,
          className: `${CSS_CLASS_NAME}-content`,
          css: {
            paddingBlockEnd: "$oneAndHalf"
          }
        }, isExpandedState ? {} : { hidden: true }),
        children
      )
    );
  }
);
Accordion.displayName = DISPLAY_NAME3;

// src/components/segmented-control/segmented-control.tsx
import * as RadixTabsPrimitive from "@radix-ui/react-tabs";

// src/components/segmented-control/segmented-control-root.tsx
import React8 from "react";
import {
  styled,
  GenesisCoreInspector,
  Tabs
} from "@leagueplatform/genesis-core";
var DISPLAY_NAME4 = "SegmentedControl";
var BaseSegmentedRoot = styled(Tabs.Root, {
  width: "fit-content",
  backgroundColor: "$surfaceBackgroundPrimary",
  border: "1px solid $onSurfaceBorderSubdued",
  borderRadius: "$pill",
  padding: "$half",
  boxShadow: "$card"
});
var SegmentedControlRoot = (_a) => {
  var _b = _a, {
    children,
    className,
    css,
    segmentedControlName,
    defaultSelectedControlId,
    "data-testid": testId = `GDS-${DISPLAY_NAME4}`
  } = _b, props = __objRest(_b, [
    "children",
    "className",
    "css",
    "segmentedControlName",
    "defaultSelectedControlId",
    "data-testid"
  ]);
  const [toggleValue, setToggleValue] = React8.useState(
    defaultSelectedControlId
  );
  const onValueChange = React8.useCallback((id) => {
    if (id) {
      setToggleValue(id);
    }
  }, []);
  return /* @__PURE__ */ React8.createElement(GenesisCoreInspector, { displayName: DISPLAY_NAME4 }, /* @__PURE__ */ React8.createElement(
    Tabs.Root,
    __spreadValues({
      className: [`GDS-segment-control`, className].join(" "),
      css,
      "aria-describedby": segmentedControlName,
      defaultValue: defaultSelectedControlId,
      value: toggleValue,
      onValueChange,
      "data-testid": testId
    }, props),
    children
  ));
};
SegmentedControlRoot.displayName = DISPLAY_NAME4;

// src/components/segmented-control/segmented-control-button.tsx
import React9 from "react";
import {
  GenesisCoreInspector as GenesisCoreInspector2,
  styled as styled2,
  Tabs as Tabs2,
  focusOutlineInner
} from "@leagueplatform/genesis-core";
var DISPLAY_NAME5 = "SegmentControlButton";
var buttonStyles = {
  typography: "$subtitleTwo",
  backgroundColor: "$none",
  borderWidth: "$thin",
  padding: "$half $one",
  cursor: "pointer",
  color: "$primaryTextSubdued",
  borderColor: "transparent",
  borderRadius: "$pill",
  margin: "$none $quarter",
  width: "fit-content",
  "&:hover": {
    backgroundColor: "$primaryBackgroundHovered",
    color: "$onSurfaceTextReversed"
  },
  '&[class*="GDS"]:focus': __spreadValues({}, focusOutlineInner),
  "&:active": {
    outline: "$transparent"
  },
  '&[aria-selected="true"], &[data-state="on"]': {
    backgroundColor: "$interactiveActionPrimary",
    color: "$onSurfaceTextReversed"
  }
};
var BaseToggle = styled2(Tabs2.Tab, __spreadValues({}, buttonStyles));
var Button = (_a) => {
  var _b = _a, {
    children,
    className,
    css,
    value,
    "data-testid": testId = `GDS-${DISPLAY_NAME5}`
  } = _b, props = __objRest(_b, [
    "children",
    "className",
    "css",
    "value",
    "data-testid"
  ]);
  return /* @__PURE__ */ React9.createElement(GenesisCoreInspector2, { displayName: DISPLAY_NAME5 }, /* @__PURE__ */ React9.createElement(
    BaseToggle,
    __spreadValues({
      className: [`GDS-segment-control-button`, className].join(" "),
      css: __spreadValues({}, css),
      key: value,
      value,
      "data-testid": testId,
      "data-segment": value
    }, props),
    children
  ));
};

// src/components/segmented-control/segmented-control-list.tsx
import React10 from "react";
import {
  styled as styled3,
  Tabs as Tabs3,
  GenesisCoreInspector as GenesisCoreInspector3
} from "@leagueplatform/genesis-core";
var DISPLAY_NAME6 = "SegmentControlList";
var MAX_CHILDREN = 4;
var BaseSegmentedTabList = styled3(Tabs3.TabList, {
  width: "fit-content",
  backgroundColor: "$surfaceBackgroundPrimary",
  border: "1px solid $onSurfaceBorderSubdued",
  borderRadius: "$pill",
  padding: "$half",
  boxShadow: "$card"
});
var List = (_a) => {
  var _b = _a, {
    className,
    children,
    "data-testid": testId = `GDS-${DISPLAY_NAME6}`
  } = _b, props = __objRest(_b, [
    "className",
    "children",
    "data-testid"
  ]);
  if (!children || React10.Children.count(children) > MAX_CHILDREN) {
    console.warn(
      `There must be at least 1 but no more than ${MAX_CHILDREN} segments.`
    );
  }
  const firstChildren = React10.Children.toArray(children).slice(0, MAX_CHILDREN);
  return /* @__PURE__ */ React10.createElement(GenesisCoreInspector3, { displayName: DISPLAY_NAME6 }, /* @__PURE__ */ React10.createElement(
    BaseSegmentedTabList,
    __spreadValues({
      "data-testid": testId,
      className: [`GDS-segment-control-button-list`, className].join(" ")
    }, props),
    firstChildren
  ));
};

// src/components/segmented-control/segmented-control.tsx
var SegmentedControl = {
  Root: SegmentedControlRoot,
  Button,
  List
};
SegmentedControl.Root.displayName = "SegmentedControl";
SegmentedControl.List.displayName = "SegmentControlList";
SegmentedControl.Button.displayName = "SegmentControlButton";

// src/components/list-item/list-item.tsx
import * as React11 from "react";
import {
  Box as Box6,
  Divider,
  Icon as Icon3,
  UtilityText,
  styled as styled4
} from "@leagueplatform/genesis-core";
var LiContainer = styled4("li", {
  display: "flex",
  flexDirection: "column"
});
var RowBox = styled4(Box6, {
  display: "flex",
  gap: "$half",
  variants: {
    size: {
      compact: {
        paddingBlock: "$half"
      },
      standard: {
        paddingBlock: "$one"
      }
    },
    divider: {
      true: {
        paddingBlock: "$half"
      },
      false: {
        paddingBlock: "$none"
      }
    }
  },
  compoundVariants: [
    {
      size: "compact",
      divider: true,
      css: {
        paddingBlock: "$quarter"
      }
    },
    {
      size: "standard",
      divider: true,
      css: {
        paddingBlock: "$half"
      }
    },
    {
      size: "compact",
      divider: false,
      css: {
        paddingBlock: "$half"
      }
    },
    {
      size: "standard",
      divider: false,
      css: {
        paddingBlock: "$threeQuarters"
      }
    }
  ]
});
var DISPLAY_NAME7 = "ListItem";
var ListItem = ({
  "data-testid": testId = `GDS-${DISPLAY_NAME7}`,
  icon,
  iconAltText = "List item icon",
  iconTint = "$onSurfaceIconPrimary",
  size = "standard",
  label,
  compactLabelStyle = "$bodyTwo",
  divider = false
}) => /* @__PURE__ */ React11.createElement(LiContainer, { "data-testid": testId }, /* @__PURE__ */ React11.createElement(RowBox, { size, divider }, icon && /* @__PURE__ */ React11.createElement(
  Icon3,
  {
    css: { marginBlockStart: "$eighth" },
    size: "$one",
    "data-testid": "icon",
    icon,
    tint: iconTint,
    label: iconAltText
  }
), /* @__PURE__ */ React11.createElement(
  UtilityText,
  {
    css: {
      typography: compactLabelStyle
    }
  },
  label
)), divider && /* @__PURE__ */ React11.createElement(Divider, { css: { marginY: "$eighth" }, "data-testid": "divider" }));
ListItem.displayName = DISPLAY_NAME7;

// src/components/table/table.component.tsx
import * as React12 from "react";
import {
  Box as Box7,
  styled as styled5,
  focusOutlineOuter as focusOutlineOuter2,
  VisuallyHidden as VisuallyHidden2
} from "@leagueplatform/genesis-core";

// src/utils/format-className.util.ts
var formatClassName = (className, classNameProp) => [className, classNameProp].join(" ");

// src/components/table/table.component.tsx
var DISPLAY_NAME8 = "Table";
var backgroundColorMap = {
  primary: "$surfaceBackgroundPrimary",
  secondary: "$surfaceBackgroundSecondary",
  tertiary: "$surfaceBackgroundTertiary"
};
var TableHeadBase = styled5("thead", {});
function TableHead(_a) {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ React12.createElement(
    TableHeadBase,
    __spreadValues({
      className: formatClassName("GDS-table-row", className)
    }, props),
    children
  );
}
var TableRowBase = styled5("tr", {});
function TableRow(_a) {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ React12.createElement(
    TableRowBase,
    __spreadValues({
      className: formatClassName("GDS-table-row", className)
    }, props),
    children
  );
}
var TableBodyBase = styled5("tbody", {
  "& tr:nth-child(1) td": {
    borderBlockStart: "none"
  }
});
function TableBody(_a) {
  var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */ React12.createElement(
    TableBodyBase,
    __spreadValues({
      className: formatClassName("GDS-table-body", className)
    }, props),
    children
  );
}
var TableCellBase = styled5("td", {
  displayName: `${DISPLAY_NAME8}Cell`,
  padding: "$one",
  borderBlockStartColor: "$onSurfaceBorderSubdued",
  borderBlockStartWidth: "$thin",
  borderBlockStartStyle: "solid",
  typography: "$bodyOne",
  color: "$onSurfaceTextPrimary"
});
function TableCell(_a) {
  var _b = _a, {
    backgroundColor: backgroundColorProp = "primary",
    className
  } = _b, props = __objRest(_b, [
    "backgroundColor",
    "className"
  ]);
  const backgroundColor = backgroundColorMap[backgroundColorProp];
  return /* @__PURE__ */ React12.createElement(
    TableCellBase,
    __spreadValues({
      className: formatClassName("GDS-table-cell", className),
      css: { backgroundColor }
    }, props)
  );
}
var TableHeaderCellBase = styled5("th", {
  textAlign: "start",
  padding: "$one",
  typography: "$subtitleTwo"
});
function TableHeader(_a) {
  var _b = _a, {
    label,
    hideLabel,
    backgroundColor: backgroundColorProp = "secondary",
    css,
    scope = "col",
    className
  } = _b, props = __objRest(_b, [
    "label",
    "hideLabel",
    "backgroundColor",
    "css",
    "scope",
    "className"
  ]);
  const backgroundColor = backgroundColorMap[backgroundColorProp];
  const cellContent = hideLabel ? /* @__PURE__ */ React12.createElement(VisuallyHidden2, null, label) : label;
  return /* @__PURE__ */ React12.createElement(
    TableHeaderCellBase,
    __spreadValues({
      scope,
      css: __spreadValues({ backgroundColor }, css),
      className: formatClassName("GDS-table-header", className)
    }, props),
    cellContent
  );
}
var borderStyles = {
  borderColor: "$onSurfaceBorderSubdued",
  borderRadius: "$small",
  borderStyle: "solid",
  borderWidth: "$thin"
};
var TableBase = styled5("table", {});
function TableWrapper({
  tableName,
  border,
  isResponsive,
  children
}) {
  const tableWrapperClass = "GDS-table-wrapper";
  if (!isResponsive) {
    return /* @__PURE__ */ React12.createElement(
      Box7,
      {
        className: tableWrapperClass,
        css: __spreadProps(__spreadValues({}, border && borderStyles), { width: "100%" })
      },
      children
    );
  }
  return /* @__PURE__ */ React12.createElement(
    Box7,
    {
      as: "section",
      "aria-label": tableName,
      tabIndex: 0,
      className: tableWrapperClass,
      css: __spreadValues({
        overflowX: "auto",
        width: "100%",
        '&[class*="GDS"]:focus': {
          outline: "initial"
        },
        '&[class*="GDS"]:focus-visible': __spreadValues({}, focusOutlineOuter2)
      }, border && borderStyles)
    },
    children
  );
}
function Table(_a) {
  var _b = _a, {
    border,
    className,
    children,
    css,
    isResponsive = true,
    tableName
  } = _b, props = __objRest(_b, [
    "border",
    "className",
    "children",
    "css",
    "isResponsive",
    "tableName"
  ]);
  return /* @__PURE__ */ React12.createElement(
    TableWrapper,
    {
      tableName,
      border,
      isResponsive
    },
    /* @__PURE__ */ React12.createElement(
      TableBase,
      __spreadValues({
        "aria-label": tableName,
        css: __spreadValues({ borderCollapse: "collapse", width: "100%" }, css),
        className: formatClassName("GDS-table", className)
      }, props),
      children
    )
  );
}
Table.displayName = DISPLAY_NAME8;
Table.Head = TableHead;
Table.Row = TableRow;
Table.Body = TableBody;
Table.Cell = TableCell;
Table.Header = TableHeader;

// src/components/video/video.tsx
import React14, {
  useRef,
  forwardRef as forwardRef6,
  useMemo as useMemo3,
  useEffect as useEffect2,
  useCallback as useCallback2
} from "react";
import videoJsBase from "video.js";
import {
  Box as Box9
} from "@leagueplatform/genesis-core";

// src/components/video/styles.ts
var GDSVideoTheme = {
  controlBackground: "rgba(8, 8, 8, 0.8)",
  controlHover: "rgba(8, 8, 8, 1)",
  remainingProgress: "rgba(101, 105, 125, 1)",
  bufferProgress: "rgba(117, 131, 149, 1)",
  progress: "rgba(255, 255, 255, 1)",
  menuItemHover: "rgba(255, 255, 255, 0.33)"
};
var EASE = "250ms ease-in-out";
var TRANSITION = `all ${EASE}`;
var VOLUME_PANEL_SELECTOR = `.vjs-volume-panel .vjs-volume-control.vjs-volume-vertical, .vjs-volume-panel.vjs-hover .vjs-mute-control~.vjs-volume-control.vjs-volume-vertical, .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-vertical, .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-vertical:active`;
var GDSVideoJSStyleOverrides = {
  $$videoIconSize: "clamp($sizes$one, 3.75vw ,$sizes$oneAndHalf)",
  // (24px / 640px) * 100vw = 3.75vw. icon max height = 24px at 640px
  $$videoControlsGap: "clamp($half, 2.5vw, $one)",
  // (16px / 640px) * 100 = 2.5
  ".video-js": {
    fontSize: "$bodyOne",
    // Idle play button
    ".vjs-big-play-button": {
      fontSize: "inherit",
      borderRadius: "$circle",
      border: "none",
      aspectRatio: 1,
      width: "min-content",
      padding: "$two",
      backgroundColor: GDSVideoTheme.controlBackground,
      transition: TRANSITION,
      transform: "translate(-50%, -50%)",
      margin: 0,
      ".vjs-svg-icon": {
        padding: "$threeQuarters",
        width: "auto",
        height: "100%"
      }
    },
    "&:hover .vjs-big-play-button, .vjs-big-play-button:focus": {
      backgroundColor: GDSVideoTheme.controlHover,
      transition: TRANSITION
    },
    ".vjs-volume-panel": {
      position: "initial"
    },
    [VOLUME_PANEL_SELECTOR]: {
      "&, &:active": {
        position: "absolute",
        bottom: "100%",
        left: "auto",
        transition: TRANSITION,
        margin: 0,
        justifyContent: "center"
      },
      ".vjs-volume-level .vjs-svg-icon": {
        left: "50%"
      }
    },
    // Containers for menu-trigger buttons
    ".vjs-menu-button": {
      display: "flex",
      justifyContent: "center"
    },
    // Control bar pop-up menus
    ".vjs-volume-vertical, .vjs-menu .vjs-menu-content": {
      borderRadius: "$small $small 0 0",
      backgroundColor: GDSVideoTheme.controlBackground
    },
    // Pop-up menus
    ".vjs-menu": {
      left: "auto",
      transition: TRANSITION,
      display: "block",
      height: "100%",
      "&:not(:hover)": {
        opacity: 0,
        visibility: "hidden"
      },
      // Control bar pop-up menu item, unselected + hovered
      '.vjs-menu-item:not([aria-checked="true"]):hover': {
        backgroundColor: GDSVideoTheme.menuItemHover
      }
    },
    // Hover transitions
    ".vjs-hover": {
      ".vjs-menu": {
        position: "absolute",
        left: "inherit",
        opacity: 1,
        visibility: "visible"
      }
    },
    // Control bar container
    ".vjs-control-bar": {
      border: "none",
      borderRadius: "$large",
      fontSize: "$caption",
      lineHeight: "auto",
      inset: "$space$one",
      bottom: "$space$one",
      top: "auto",
      maxWidth: "calc(100% - $space$one * 2)",
      margin: "0 auto",
      backgroundColor: GDSVideoTheme.controlBackground,
      justifyContent: "space-between",
      gap: "1%",
      padding: "$one",
      height: "auto",
      alignItems: "center",
      // Control bar elements
      ".vjs-control": {
        alignItems: "center",
        justifyContent: "center",
        width: "auto",
        minWidth: "auto"
      },
      ".vjs-playback-rate-value,.vjs-time-control": {
        lineHeight: "initial"
      },
      ".vjs-menu-button": {
        display: "flex",
        alignItems: "center",
        padding: 0,
        ".vjs-playback-rate-value,.vjs-time-control": {
          fontSize: "$bodyOne",
          position: "relative"
        }
      }
    },
    ".vjs-remaining-time": {
      paddingInlineStart: 0,
      lineHeight: "auto"
    },
    ".vjs-progress-control": {
      gridColumn: "progress-bar",
      ".vjs-svg-icon": {
        height: "initial"
      }
    },
    // Progress slider: background/unloaded
    ".vjs-slider": {
      backgroundColor: GDSVideoTheme.remainingProgress
    },
    // Progress slider: buffer progress
    ".vjs-load-progress [data-start]": {
      backgroundColor: GDSVideoTheme.bufferProgress
    },
    // Icons
    ".vjs-svg-icon": {
      fontSize: "$bodyOne",
      transition: "filter 150ms ease-out",
      height: "$$videoIconSize",
      // width: 'auto',
      aspectRatio: "1 / 1",
      // maxHeight: '$oneAndHalf',
      // minHeight: '$one',
      // width: '100%',
      // height: '100%',
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      svg: {
        height: "100%"
      }
    },
    // Audio-only mode
    "&.vjs-audio-only-mode": {
      ".vjs-control-bar": {
        bottom: "auto"
      }
    },
    // Error container
    ".vjs-error-display": {
      typography: "$bodyOne",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      ".vjs-modal-dialog-content": {
        position: "relative",
        height: "auto",
        padding: "0 10%",
        maxWidth: "80ch"
        // See: https://www.w3.org/WAI/tutorials/page-structure/styling/#line-length
      }
    }
  }
};
var GDSVideoFrameStyles = __spreadValues({
  borderRadius: "$small"
}, GDSVideoJSStyleOverrides);
var accordionStyleOverrides = {
  marginBlockStart: 0,
  padding: 0,
  border: "none",
  ".GDS-accordion-button": {
    padding: 0,
    alignItems: "center",
    ".GDS-accordion-button-icon": {
      color: "$onSurfaceIconPrimary"
    }
  },
  ".GDS-accordion-content": {
    padding: 0,
    marginBlockStart: "$oneAndHalf",
    backgroundColor: "$surfaceBackgroundSecondary",
    typography: "$label",
    maxHeight: "180px",
    overflow: "auto"
  }
};

// src/components/video/video-transcript.component.tsx
import React13 from "react";
import {
  Box as Box8,
  Scrollable,
  ParagraphText as ParagraphText3,
  HeadingText as HeadingText4
} from "@leagueplatform/genesis-core";
var Transcript = ({
  transcript
}) => {
  const { content, buttonLabel, heading } = transcript || {};
  if (!content || !buttonLabel || !heading)
    return null;
  return /* @__PURE__ */ React13.createElement(
    Box8,
    {
      css: {
        paddingBlock: "$oneAndHalf",
        borderBlockEnd: "$borderWidths$thin $onSurfaceBorderDefault solid"
      }
    },
    /* @__PURE__ */ React13.createElement(
      Accordion,
      {
        heading: buttonLabel,
        className: "GDS-video-transcript",
        css: accordionStyleOverrides
      },
      /* @__PURE__ */ React13.createElement(
        Scrollable,
        {
          height: "100%",
          css: {
            padding: "$half"
          }
        },
        /* @__PURE__ */ React13.createElement(HeadingText4, { level: "4", size: "xs", css: { marginBlockEnd: "$one" } }, heading),
        /* @__PURE__ */ React13.createElement(
          ParagraphText3,
          {
            css: {
              // Break lines at newline characters
              whiteSpace: "pre-line",
              // Label typography for text directly in the element (plain text)
              typography: "$label",
              // Add spacing between paragraphs
              p: { marginBlockEnd: "$threeQuarters" },
              // Label font size for all children elements (rich text)
              "*": { fontSize: "$label" }
            }
          },
          content
        )
      )
    )
  );
};

// src/components/video/setup.ts
import videojs from "video.js";
import { kebabCase } from "lodash";
var BaseComponent = videojs.getComponent("Component");
var GDS_VIDEO_JS_PREFIX = "GDS-video";
function appendGDSClass() {
  const elementName = kebabCase((this == null ? void 0 : this.name()) || this.constructor.name || "");
  return [GDS_VIDEO_JS_PREFIX, elementName].filter(Boolean).join("-");
}
BaseComponent.prototype.buildCSSClass = appendGDSClass;

// src/components/video/video.tsx
import "video.js/dist/video-js.min.css";
var typedVideoJs = videoJsBase;
var DISPLAY_NAME9 = "Video";
var GDS_VIDEO_STATIC_ERROR = `Unknown error with the video player, please reload the page.`;
var GDSDefaultVideoJSOptions = {
  autoplay: false,
  bigPlayButton: true,
  controlBar: {
    volumePanel: { inline: false },
    progressControl: { seekBar: true }
  },
  controls: true,
  disablePictureInPicture: false,
  // @ts-expect-error – known property
  experimentalSvgIcons: true,
  fluid: true,
  notSupportedMessage: GDS_VIDEO_STATIC_ERROR,
  playbackRates: [0.25, 0.5, 1, 1.5, 2],
  responsive: true,
  retryOnError: true
};
var Video = forwardRef6(
  (props, ref) => {
    const _a = props, {
      onReady,
      className,
      css,
      "data-testid": testId = `GDS-${DISPLAY_NAME9}`,
      transcript
    } = _a, videoJsOptions = __objRest(_a, [
      "onReady",
      "className",
      "css",
      "data-testid",
      "transcript"
    ]);
    const videoRef = useRef(null);
    const playerRef = useRef(typeof ref !== "function" ? ref == null ? void 0 : ref.current : null);
    const aggregateOptions = useMemo3(() => {
      const _a2 = videoJsOptions != null ? videoJsOptions : {}, { src, sources = [] } = _a2, rawOptions = __objRest(_a2, ["src", "sources"]);
      const normalizedSources = src ? [...sources, { src }] : sources;
      return __spreadProps(__spreadValues(__spreadValues({}, GDSDefaultVideoJSOptions), rawOptions), {
        sources: normalizedSources
      });
    }, [videoJsOptions]);
    useEffect2(() => {
      var _a2, _b, _c, _d, _e;
      const { current: player } = playerRef;
      const isConnected = (_a2 = videoRef.current) == null ? void 0 : _a2.isConnected;
      if (!isConnected)
        return;
      if (!player && videoRef.current) {
        const videoElement = document.createElement("video");
        (_b = videoElement.classList) == null ? void 0 : _b.add("video-js", "GDS-video");
        (_d = (_c = videoRef.current) == null ? void 0 : _c.appendChild) == null ? void 0 : _d.call(_c, videoElement);
        playerRef.current = typedVideoJs(
          videoElement,
          aggregateOptions,
          function onVideoReady() {
            typedVideoJs.log("Video player is ready");
            onReady == null ? void 0 : onReady(this);
          }
        );
      } else {
        const { autoplay, sources, src, aspectRatio, disablePictureInPicture } = aggregateOptions;
        player == null ? void 0 : player.autoplay(autoplay || false);
        const newSrc = src || sources;
        if (newSrc)
          player == null ? void 0 : player.src(newSrc);
        if (aspectRatio)
          (_e = player == null ? void 0 : player.aspectRatio) == null ? void 0 : _e.call(player, aspectRatio);
        if (disablePictureInPicture != null)
          player == null ? void 0 : player.disablePictureInPicture(disablePictureInPicture);
      }
    }, [aggregateOptions, onReady, videoRef]);
    const onVisibilityChange = useCallback2(
      (event) => {
        var _a2;
        return (_a2 = playerRef.current) == null ? void 0 : _a2.trigger(event);
      },
      []
    );
    useEffect2(() => {
      const { current: player } = playerRef;
      document.addEventListener("visibilitychange", onVisibilityChange);
      return () => {
        document.removeEventListener("visibilitychange", onVisibilityChange);
        if (player && !(player == null ? void 0 : player.isDisposed())) {
          player == null ? void 0 : player.dispose();
          playerRef.current = null;
        }
      };
    }, [onVisibilityChange]);
    return (
      /* Video Layout */
      /* @__PURE__ */ React14.createElement(
        Box9,
        {
          "data-vjs-player": true,
          "data-testid": testId,
          className: [`GDS-video-layout`, className].join(" "),
          css: __spreadValues(__spreadValues({}, GDSVideoFrameStyles), css)
        },
        /* @__PURE__ */ React14.createElement(Box9, { ref: videoRef, className: "GDS-video-container" }),
        /* @__PURE__ */ React14.createElement(Transcript, { transcript })
      )
    );
  }
);
Video.displayName = DISPLAY_NAME9;
export {
  Accordion,
  GDSDefaultVideoJSOptions,
  ListItem,
  Pagination,
  SampleComponent,
  SectionHeader,
  SegmentedControl,
  SegmentedControlRoot,
  SidebarLayout,
  Table,
  Video
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/genesis-core-alpha'] = window.leagueSDKsPresent['@leagueplatform/genesis-core-alpha'] || [];
    window.leagueSDKsPresent['@leagueplatform/genesis-core-alpha'].push('2.27.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/genesis-core-alpha'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/genesis-core-alpha module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map